<template>
  <div class="bottom">
    <div class="img" @click="pack = !pack">
      <pdf ref="pdf" v-for="i in numPages" :key="i" :src="src" :page="i"> </pdf>
    </div>
  </div>
</template>
<script>
import pdf from "vue-pdf";
export default {
  components: { pdf },
  data() {
    return {
      src: undefined,
      numPages: undefined,
      pdfUrl: "/static/Attachment/Help.pdf",
    };
  },
  methods: {
    //#region 计算pdf页面总数
    getNumPages(url) {
      let loadingTask = pdf.createLoadingTask(url);
      this.src = loadingTask;
      loadingTask.promise
        .then((pdf) => {
          this.numPages = pdf.numPages;
        })
        .catch((err) => {
          console.error("pdf 加载失败", err);
        });
    },
  },
  mounted() {
    this.getNumPages(this.pdfUrl);
  },
};
</script>
<style scoped>
.bottom {
  flex: 1;
  background: #fff;
  margin-top: 15px;
  overflow: hidden;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090, direction=120, strength=4);
  -moz-box-shadow: 2px 2px 10px #909090;
  -webkit-box-shadow: 2px 2px 10px #909090;
  box-shadow: 2px 2px 10px #909090;
}

.bottom .img {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/Help.vue